import { IoChevronBack } from 'react-icons/io5';
import { StyledButton } from '../button/Button';
import type { StyledButtonProps } from '../button/Button';
import { useNavigate } from 'react-router';

export type BackButtonProps = StyledButtonProps;

export const BackButton = (props: BackButtonProps) => {
	const navigate = useNavigate();
	return (
		<StyledButton
			type="link"
			className="back-button"
			icon={<IoChevronBack size={25} />}
			onClick={() => navigate(-1)}
			{...props}
		/>
	);
};
